


























import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import WindowEvent from "@/decorators/WindowEvent";

@Component
export default class GuideContainer extends Vue {
  @Prop({ required: true }) readonly guidePath!: string;

  @Ref() readonly panel!: HTMLElement;

  scrolled = false;

  get guideComponent() {
    return () => import(`@/components/Guides/${this.guidePath}.vue`);
  }

  mounted() {
    document.body.appendChild(this.$el);
  }

  destroyed() {
    this.$el.remove();
  }

  onPanelScroll() {
    this.scrolled = this.panel.scrollTop > 0;
  }

  scrollToTop() {
    this.panel.scrollTo({ top: 0, behavior: "smooth" });
  }

  @WindowEvent("keydown")
  onKeyDown(event: KeyboardEvent) {
    if (event.key === "Escape") {
      this.$emit("guide-close");
    }
  }
}
